import { withStyles } from '@material-ui/core/styles';
import MuiBox from '@material-ui/core/Box';
import MuiTypography from '@material-ui/core/Typography';
import MuiButton from '@material-ui/core/Button';
import MuiChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MuiChevronRightIcon from '@mui/icons-material/ChevronRight';

const styles = theme => ({
  container: {
    width: '100%',
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  button: {
    borderRadius: 100,
    minWidth: 32,
    minHeight: 32,
    padding: 0,
  },
});

const QueryPagination = ({ page, totalItems, itemsPerPage, handlePageChange, ...props }) => {
  const { classes } = props;

  const start = page * itemsPerPage + 1;
  const end = Math.min((page + 1) * itemsPerPage, totalItems);

  const handlePrevious = () => {
    handlePageChange(page - 1);
  };
  const handleNext = () => {
    handlePageChange(page + 1);
  };

  return (
    <MuiBox className={classes.container}>
      <MuiTypography variant="body2">{`${start}-${end} of ${totalItems}`}</MuiTypography>
      <MuiButton
        variant="text"
        color="primary"
        className={classes.button}
        disabled={page === 0}
        onClick={handlePrevious}>
        <MuiChevronLeftIcon />
      </MuiButton>
      <MuiButton
        variant="text"
        color="primary"
        className={classes.button}
        disabled={page === Math.ceil(totalItems / itemsPerPage) - 1}
        onClick={handleNext}>
        <MuiChevronRightIcon />
      </MuiButton>
    </MuiBox>
  );
};

export default withStyles(styles)(QueryPagination);
